import {
    assistantAsking, assistantAskingForAction,
    assistantAskingForContext, assistantAskingForExample,
    assistantAskingForGenre, assistantAskingForInstructions, assistantAskingForRequirements, assistantAskingForSchema,
    assistantAskingForSynopsis, systemInstruction, userSaying
} from "../../../../../../../ai/Utils";
import {DraftScene} from "../../../../../../../feature/Draft";

export const generateShotsPrompt = (vars: {
    scene: DraftScene,
    prevScene?: DraftScene,
    nextScene?: DraftScene,
    genres: string[],
    synopsis: string,
    prevShots?: { shot: number, content: string }[] | undefined,
    person: number,
    context?: string[]
}) => systemInstruction("Ты профессиональный писатель")
    .concat(userSaying("Я работаю над созданием литературного произведения"))
    .concat(assistantAskingForGenre(vars.genres))
    .concat(assistantAskingForSynopsis(vars.synopsis))
    .concat(assistantAsking("Опиши кратко сцену, над которой ведется работа", vars.scene.description))
    .concat(assistantAsking("Опиши кратко предыдущую сцену", vars.prevScene?.description))
    .concat(assistantAsking("Опиши кратко следующую сцену", vars.nextScene?.description))
    .concat(assistantAsking("Опиши содержимое предыдущих кадров", vars.prevShots ? JSON.stringify(vars.prevShots) : undefined))
    .concat(assistantAsking("От какого лица нарратив?", `От ${vars.person}-го лица`))
    .concat(assistantAskingForContext(vars.context))
    .concat(assistantAskingForInstructions([
        "Проанализируй кратко содержание сцены и следующей сцены",
        "Используй следующую сцену только для того, что бы понять где должна закончится эта сцена",
        "Разбей сцену на кадры",
        "Опиши каждый кадр как можно подробнее",
        "Добавь диалоги и монологи персонажей",
        "Добавь выбор если это необходимо для сюжета",
        "Останови генерацию кадров если был добавлен выбор"
    ]))
    .concat(assistantAskingForRequirements([
        "Не используй действия, события и диалоги из следующей сцены",
        "Не забегай вперед, не добавляй ничего, что относится к следующей сцене",
        "Не повторяй диалоги из предыдущих сцен",
        "В сцене должно быть не менее 10 кадров, но это не должно влиять на качество и объем текста",
        "Добавляй в сцены кадры, где персонажи могут просто общаться на отвлеченные темы, не относящиеся к сюжету, например рассказывать истории, анекдоты, что-то из личной жизни и т.д.",
        "Не должно быть кадров только с описанием, обязательно должен присутствовать диалог или монолог персонажей",
        "Описание кадра должно быть от имени автора",
        "Описание окружения должно быть от лица главного героя если важно передать это читателю",
        "Окружение нужно описывать с точки зрения главного героя, как он его чувствует и как он к нему относится",
        "Все описания помещай в поле description",
        "В поле narration помещай только диалоги, монологи, мысли персонажей и повествование автора. Любой другой текст помещай в description",
        "Не нужно добавлять имя персонажа в текст нарратива",
        "Содержание сцены должно быть логичным и согласовываться с предыдущими и следующими сценами",
        "Диалоги и монологи должны быть натуральными, наполненными, логичными и соответствовать персонажам.",
        "Каждый кадр должен включать место действия и время суток",
        "Кадр может включать что-то одно: действие персонажа, диалог, внутренний монолог, описание окружения",
        "Кадры должны быть логичными и последовательными",
        "Если возможен выбор, то добавь варианты выбора",
        "Выбор в кадре необязателен. Добавляй выбор только тогда, года это необходимо для сюжета",
        "Количество выборов не должно превышать количество линий сюжета",
        "Не добавляй выбор если в реальности в нем нет необходимости. Например если детективу нужно опросить свидетелей и осмотреть место преступления, то такой выбор добавлять не нужно так как это не правдоподобно потому что профессия детектива обязывает его выполнить все действия",
        "Если у персонажа нет имени и явно не указано, что это неизвестный или незнакомец, то придумай имя самостоятельно",
        "Результат должен быть в формате json"
    ]))
    .concat(assistantAskingForSchema('{"data": [{"id":number, "description":string, "environment":"Интерьер"|"Экстерьер", "place":string, "time":"Утро"|"Ночь"|"День"|"Вечер", "narration":{"text":string, "character":string, "expression":string}}, choice:[{"line":number, "title":string}]}'))
    .concat(assistantAskingForExample({
            data: [
                {
                    id: 1,
                    description: "Детектив наслаждается пейзажем рядом с местом преступления",
                    environment: "Экстерьер",
                    place: "Подворотня на Ривер Стрит",
                    time: "Утро",
                    narration: {
                        text: "Боже, как же давно я не бывал в подобных местах. На первый взгляд заброшенная подворотня оставляет странное чувство. Что же оно напоминает? Точно! Ник - мой друг детcтва жил в подобном месте!",
                        character: "Детектив",
                        expression: "Задумчиво"
                    }
                }
            ]
        }
    ))
    .concat(assistantAskingForAction(`Сгенерируй кадры для сцены.`))
